import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import * as config from '../config';
import { apiRequest, apiRequestBodyParams, apiRequestParams, httpApiRequest } from './equipment.services';

export const getUserRoleList = apiRequest('get', 'user-roles/list', 'GET_USER_ROLE_LIST')
export const getUsersList = apiRequest('get', 'peoples/list', 'GET_USERS_LIST')

export const getAvailableRemainingPeople = createAsyncThunk(
    'GET_AVAILABLE_PEOPLE',
    async (data) => {
      const { url: baseUrlWithParams, ...queryParams } = data;
      const [basePath, existingQuery] = baseUrlWithParams.split("?");
      const searchParams = new URLSearchParams(existingQuery);
      Object.entries(queryParams).forEach(([key, value]) => {
        if (!searchParams.has(key)) {
          searchParams.append(key, value);
        }
      });
  
      const fullUrl = `${config.API_URL}${basePath}?${searchParams.toString()}`;
      const response = await axios.get(fullUrl);
      return response.data;
    }
  );
  
export const getPeopleDetail = apiRequestParams('get', 'peoples/detail', 'GET_PEOPLE_DETAIL')
export const addPeople = httpApiRequest('post', 'user/sub-user-create', 'ADD_PEOPLE')
export const restoreEmail = httpApiRequest('post', 'user/restore', 'RESTORE_EMAIL')
export const resendWelcomeEmail = httpApiRequest('post', 'users/resend-welcome-mail', 'RESEND_WELCOME_EMAIL')

export const addLocationsToPeople = apiRequest('post', 'location-users/add-multiple-locations', 'ADD_LOCATIONS_TO_PEOPLE')
export const deletePeopleLocation = apiRequestBodyParams('delete', 'location-users/remove', 'DELETE_PEOPLE_LOCATION')

export const updatePeopleDetail = apiRequestParams('patch', 'users/update', 'UPDATE_PEOPLE_DETAIL')

export const getUserTypes = apiRequest('get', 'user-types/list', 'GET_USER_TYPES')